import { ESportsRoutes, ESportsRoutesEN } from '@/app/models/sports.model';
import { normalizeRoute } from '@/tools/utils/utils';

import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class SportGuard {
  private router = inject(Router);

  private sportType = Object.values(ESportsRoutes).map(normalizeRoute);
  private sportTypeEn = Object.values(ESportsRoutesEN).map(normalizeRoute);

  private validSports = [...this.sportType, ...this.sportTypeEn];

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const sport = route.params['sport'];

    if (!sport) return true;

    if (this.validSports.includes(sport)) {
      return true;
    }

    return this.router.parseUrl('/404');
  }
}
